var $d63a73d4484283ea$exports = {};
$d63a73d4484283ea$exports = {
    "backButton": (args)=>`Reveni\u{21B}i la ${args.prevMenuButton}`,
    "moreActions": `Mai multe ac\u{21B}iuni`,
    "unavailable": `Indisponibil, extinde\u{21B}i pentru detalii`
};


export {$d63a73d4484283ea$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
